import styled from 'styled-components';

import { createVar, vars } from '~/theme';

const _selectedBorderColor = createVar('selectedBorderColor');

const dataHoverSelector = '[data-hover="true"]';

export const Container = styled.div(({ theme }) => ({
  ...vars({
    [_selectedBorderColor]: 'transparent',
  }),

  position: 'relative',

  boxSizing: 'border-box',

  width: '100%',
  borderRadius: '5rem',
  boxShadow: [
    `0 3rem 6rem ${theme.card.primary.shadow}`,
    `0 0 0 4rem ${_selectedBorderColor}`,
  ].join(','),
  background: theme.card.primary.bg,

  color: theme.card.primary.text,

  transition: [
    'transform 250ms linear',
    'opacity 250ms linear',
    'outline 250ms linear',
  ].join(', '),

  '@media (prefers-reduced-motion)': {
    transition: 'none',
  },

  '&[aria-selected="true"]': {
    ...vars({
      [_selectedBorderColor]: theme.card.primary.active,
    }),
  },

  '&[tabindex="0"]': {
    cursor: 'pointer',
  },

  '&[aria-disabled="true"]': {
    cursor: 'not-allowed',

    opacity: 0.3,
  },

  [`&${dataHoverSelector}:hover`]: {
    transform: 'scale(1.0125)',
  },

  '&:focus-within': {
    outline: `3.5rem solid ${theme.card.primary.focus}`,
  },

  '&::after': {
    content: '""',

    position: 'absolute',
    inset: 0,
    zIndex: theme.overlayPosition.layerNegative,

    borderRadius: 'inherit',
    boxShadow: `0 4.5rem 10.5rem ${theme.card.primary.shadowHover}`,
    opacity: 0,

    transition: 'inherit',

    [`${dataHoverSelector}:hover&`]: {
      opacity: 1,
    },
  },
}));
